// Data structure for Site Map and Support Chat analysis
// Supports RU, EN, KY keywords and fuzzy searching

export const siteStructure = [
    {
      id: 'main',
      title: 'Главная / Main / Башкы бет',
      path: '/?view=main',
      description: 'Главная страница платформы NCORE. Башкы бет.',
      keywords: [
        'главная', 'дом', 'старт', 'начало', 'домой', 'вернуться', // RU
        'home', 'main', 'start', 'index', 'root', 'back', // EN
        'башкы', 'бет', 'негизги', 'үй', 'баштоо' // KY
      ],
      children: []
    },
    {
      id: 'about',
      title: 'О нас / About Us / Биз жөнүндө',
      path: '/?view=about',
      type: 'section',
      description: 'Информация о компании NCORE. Биздин компания жөнүндө маалымат.',
      keywords: [
        'о нас', 'компания', 'команда', 'миссия', 'кто мы', 'информация', 'про нас', // RU
        'about', 'us', 'company', 'team', 'mission', 'info', 'who', // EN
        'биз', 'жөнүндө', 'маалымат', 'команда', 'компания', 'миссия' // KY
      ],
      children: []
    },
    {
      id: 'contacts',
      title: 'Контакты / Contacts / Байланыш',
      path: '/?view=contacts',
      type: 'section',
      description: 'Свяжитесь с нами. Биз менен байланышуу.',
      keywords: [
        'контакты', 'связь', 'телефон', 'адрес', 'почта', 'связаться', 'номер', // RU
        'contacts', 'contact', 'phone', 'address', 'mail', 'email', 'call', // EN
        'байланыш', 'телефон', 'дарек', 'почта', 'номер', 'чалуу' // KY
      ],
      children: []
    },
    {
      id: 'feedback',
      title: 'Обратная связь / Feedback / Кайтарым байланыш',
      path: '/feedback', // This remains a separate page
      description: 'Отправить отзыв или сообщить об ошибке. Пикир калтыруу.',
      keywords: [
        'обратная связь', 'отзыв', 'предложение', 'ошибка', 'баг', 'репорт', 'жалоба', 'мнение', // RU
        'feedback', 'report', 'bug', 'error', 'suggestion', 'opinion', 'review', // EN
        'пикири', 'пикир', 'сунуш', 'ката', 'баг', 'кайтарым', 'байланыш' // KY
      ],
      children: []
    },
    {
      id: 'services',
      title: 'Экосистема / Ecosystem / Экосистема',
      path: null,
      description: 'Все сервисы. Бардык сервистер.',
      keywords: ['сервисы', 'услуги', 'продукты', 'services', 'ecosystem', 'products', 'сервистер', 'кызматтар'],
      children: [
        {
          id: 'main-services',
          title: 'Основные / Main / Негизги',
          description: 'Основные сервисы',
          children: [
            {
              id: 'servers',
              title: 'Игровые сервера / Game Servers',
              path: '/?service=servers',
              description: 'Хостинг игровых серверов (CS, Minecraft). Оюндардын серверлери.',
              keywords: [
                'сервер', 'сервера', 'хостинг', 'игра', 'майнкрафт', 'кс', 'ксго', 'samp', 'gta', // RU
                'server', 'servers', 'hosting', 'game', 'minecraft', 'cs', 'csgo', 'rust', // EN
                'серверлер', 'оюн', 'гейминг', 'хост' // KY
              ],
            },
            {
              id: 'donations',
              title: 'Донаты / Donations',
              path: '/?service=donations',
              description: 'Пополнение игровых валют. Оюн валюталарын толтуруу.',
              keywords: [
                'донат', 'валюта', 'покупка', 'деньги', 'счет', 'пополнить', 'uc', 'pubg', 'алмаз', 'ге мы', // RU
                'donation', 'donate', 'currency', 'buy', 'money', 'topup', 'uc', 'diamonds', // EN
                'донат', 'акча', 'сатып', 'алуу', 'толтуруу', 'валюта' // KY
              ],
            },
            {
              id: 'community',
              title: 'Сообщество / Community',
              path: '/?service=community',
              description: 'Форум, чаты, общение. Баарлашуу жана форум.',
              keywords: [
                'сообщество', 'форум', 'чат', 'люди', 'общение', 'группа', 'обсуждение', // RU
                'community', 'forum', 'chat', 'people', 'social', 'group', 'discussion', // EN
                'коомчулук', 'форум', 'чат', 'баарлашуу', 'талкуу', 'группа' // KY
              ],
            }
          ]
        },
        {
          id: 'entertainment',
          title: 'Развлечения / Entertainment',
          description: 'Мультимедиа',
          children: [
            {
              id: 'movie',
              title: 'Фильмы / Movies / Кинолор',
              path: '/?service=movie',
              description: 'Фильмы и сериалы онлайн. Кино жана сериалдар.',
              keywords: [
                'фильм', 'кино', 'сериал', 'смотреть', 'онлайн', 'премьера', 'мультик', // RU
                'movie', 'film', 'cinema', 'series', 'watch', 'online', 'cartoon', // EN
                'кино', 'тасма', 'сериал', 'көрүү', 'онлайн', 'мультфильм' // KY
              ],
            },
            {
              id: 'music',
              title: 'Музыка / Music',
              path: '/?service=music',
              description: 'Слушать музыку. Музыка угуу.',
              keywords: [
                'музыка', 'песня', 'трек', 'слушать', 'аудио', 'плеер', 'звук', // RU
                'music', 'song', 'track', 'listen', 'audio', 'player', 'sound', // EN
                'музыка', 'ыр', 'угуу', 'үн', 'обон' // KY
              ],
            },
            {
              id: 'anime',
              title: 'Аниме / Anime',
              path: '/?service=anime',
              description: 'Аниме и манга. Аниме жана манга.',
              keywords: [
                'аниме', 'манга', 'япония', 'мультфильм', 'тайтл', // RU
                'anime', 'manga', 'japan', 'animation', // EN
                'аниме', 'манга', 'жапония' // KY
              ],
            },
            {
              id: 'media',
              title: 'Медиа / Media',
              path: '/?service=media',
              description: 'Новости и статьи. Жаңылыктар жана макалалар.',
              keywords: [
                'медиа', 'новости', 'статья', 'читать', 'блог', 'инфо', // RU
                'media', 'news', 'article', 'read', 'blog', 'info', // EN
                'медиа', 'жаңылык', 'кабар', 'макала', 'окуу' // KY
              ],
            }
          ]
        },
        {
          id: 'travel',
          title: 'Путешествия / Travel',
          description: 'Туризм',
          children: [
             {
              id: 'tourism',
              title: 'Туризм / Tourism',
              path: '/?service=tourism',
              description: 'Туры и путешествия. Саякат жана турлар.',
              keywords: [
                'туризм', 'тур', 'путешествие', 'билет', 'отель', 'бронь', 'поездка', // RU
                'tourism', 'travel', 'tour', 'ticket', 'hotel', 'booking', 'trip', // EN
                'туризм', 'саякат', 'билет', 'мейманкана', 'эс алуу' // KY
              ],
             }
          ]
        },
        {
          id: 'future',
          title: 'Скоро / Coming Soon',
          children: [
            { 
                id: 'shop', title: 'Магазин', path: '/?service=shop',
                keywords: ['магазин', 'товар', 'купить', 'shop', 'store', 'buy', 'дүкөн', 'сатып алуу']
            },
            { 
                id: 'food', title: 'Еда', path: '/?service=food',
                keywords: ['еда', 'доставка', 'кушать', 'food', 'delivery', 'eat', 'тамак', 'жеткирүү']
            },
            { 
                id: 'it', title: 'NCORE IT Услуги', path: '/?service=it',
                keywords: ['it', 'разработка', 'сайт', 'программист', 'development', 'code', 'программист', 'иштеп чыгуу']
            }, 
            { 
                id: 'events', title: 'Мероприятия', path: '/?service=events',
                keywords: ['мероприятия', 'ивенты', 'события', 'events', 'meeting', 'party', 'майрам', 'жолугушуу']
            },
            { 
                id: 'settings', title: 'Профиль', path: '/?view=profile',
                keywords: ['профиль', 'аккаунт', 'настройки', 'личный кабинет', 'profile', 'account', 'settings', 'кабинет', 'жөндөөлөр']
            },
             { 
                id: 'ai', title: 'AI Кочевник', path: '/?view=ai',
                keywords: ['ии', 'ai', 'gpt', 'бот', 'интеллект', 'умный', 'bot', 'smart', 'жасалма интеллект']
            },
            { 
                id: 'speedtest', title: 'Speed Test', path: '/?view=speedtest',
                keywords: ['скорость', 'интернет', 'спидтест', 'speed', 'internet', 'test', 'ылдамдык']
            }
          ]
        }
      ]
    }
  ];
